import { createSelector } from 'reselect';

export const selectXdkState = createSelector(
  state => (state as any).xdkStore,
  xdkStore => xdkStore,
);

export const getPageBackId = createSelector(
  selectXdkState,
  state => state.backId,
);
export const getPageExitId = createSelector(
  selectXdkState,
  state => state.exitId,
);
export const getPageFocusId = createSelector(
  selectXdkState,
  state => state.focusId,
);
export const getLastFocusedTileId = createSelector(
  selectXdkState,
  state => state.lastFocusedTile,
);
export const getShowPodcastsMenuOption = createSelector(
  selectXdkState,
  state => state.shouldShowPodcastsMenuOption,
);
export const getPageRightId = createSelector(
  selectXdkState,
  state => state.rightId,
);
export const getPageLeftId = createSelector(
  selectXdkState,
  state => state.leftId,
);

export const getKeyPressedId = createSelector(
  selectXdkState,
  state => state.keyPressedId,
);
